import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["fixedLocation", "proposedLocations", "fixedRadio", "votingRadio"]

  connect() {
    this.updateVisibility()
  }

  selectFixed(event) {
    if (event.target.tagName !== "INPUT") {
      this.fixedRadioTarget.checked = true
    }
    this.updateVisibility()
  }

  selectVoting(event) {
    if (event.target.tagName !== "INPUT") {
      this.votingRadioTarget.checked = true
    }
    this.updateVisibility()
  }

  updateVisibility() {
    const isVoting = this.votingRadioTarget.checked

    if (isVoting) {
      this.fixedLocationTarget.classList.add("hidden")
      this.proposedLocationsTarget.classList.remove("hidden")
    } else {
      this.fixedLocationTarget.classList.remove("hidden")
      this.proposedLocationsTarget.classList.add("hidden")
    }
  }
}
